import {useEffect, useState} from 'react';
import {BatteryMedium, Signal, Wifi} from 'lucide-react';
import {LanguageSwitcher, useI18n} from '../i18n';

function useClock() {
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    const timer = window.setInterval(() => setNow(new Date()), 30_000);
    return () => window.clearInterval(timer);
  }, []);
  return now;
}

export function MobileStatusBar() {
  const now = useClock();
  const {locale} = useI18n();

  return (
    <div className="safe-top relative z-20 shrink-0">
      <div className="flex h-11 items-center justify-between px-5 text-[13px] font-bold text-ink">
        <span className="tabular-nums">
          {now.toLocaleTimeString(locale, {hour: '2-digit', minute: '2-digit'})}
        </span>
        <div className="flex items-center gap-2.5 text-ink-2">
          <LanguageSwitcher />
          <Signal size={15} aria-hidden="true" />
          <Wifi size={15} aria-hidden="true" />
          <BatteryMedium size={19} aria-hidden="true" />
        </div>
      </div>
    </div>
  );
}
